<section class="edit-student-profile-container">
    <div fxLayout="column" fxLayoutAlign="center center">
        <h1><span>Edit Profile</span></h1>
        <div fxLayout="row" fxLayoutAlign="center">
            <mat-icon>profile</mat-icon>
            <span>Make changes to your Profile below.</span>
        </div>

        <mat-tab-group style="width: 100%" mat-stretch-tabs="false">
            <mat-tab label="User Settings">
                <edit-profile
                    [profileData]="profileData$ | async"
                    (processCancel)="cancel()"
                ></edit-profile>
            </mat-tab>
            <mat-tab label="Profile Image">
                <div fxLayoutAlign="center center" fxLayout="column">
                    <div fxFlex="50">
                        <profile-thumbnail
                            [profileData]="profileData$ | async"
                        >
                        </profile-thumbnail>
                    </div>
                </div>
                <div fxLayoutAlign="center center">
                    <button
                        class="standard-outline-button button-small"
                        type="button"
                        (click)="cancel()"
                    >
                        Close
                    </button>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
</section>
